<template>
	<div class="main">
		<div class="sound-box" v-if="isSounding">
			<div class="cont">
					<div class="txt-large">
						<p>我在听您说</p>
						<p>请说出您想要问的问题~</p>
					</div>
					<div class="txt-small">{{isCancel ? '松手，取消发送': '松手发送，上滑取消'}}</div>
			</div>
		</div>
		<div class="btn-recod" id="btRecoding" @touchstart="touchStart" @touchmove="touchMove" @touchend="touchEnd">
			<!-- 音波效果 -->
			<div :class="['audio',{'red':isCancel}]" v-if="isSounding">
				<div class="wave"></div>
				<div class="wave"></div>
				<div class="wave"></div>
				<div class="wave"></div>
				<div class="wave"></div>
				<div class="wave"></div>
				<div class="wave"></div>
				<div class="wave"></div>
				<div class="wave"></div>
				<div class="wave"></div>
				<div class="wave"></div>
				<div class="wave"></div>
				<div class="wave"></div>
				<div class="wave"></div>
				<div class="wave"></div>
			</div>
			<div class="not-sound-box" v-else>
				按住说话
				<span class="icon" @touchstart="switchKeyboard"><img src="@/assets/images/spark/keyboard_icon.png"/></span>
			</div>
		</div>
	</div>
</template>

<script>
	import Recorder from 'recorder-core'
	//引入pcm格式支持文件；如果需要多个格式支持，把这些格式的编码引擎js文件放到后面统统引入进来即可
	import "recorder-core/src/engine/mp3"
	import "recorder-core/src/engine/mp3-engine"
	import "recorder-core/src/engine/pcm"
	export default {
		data() {
			return {
				rec:null,
				posStart: 0,//初始化起点坐标
				posEnd: 0, //初始化终点坐标
			 	posMove: 0, //初始化滑动坐标
				isCancel:false,//触发取消发送
				isSounding:false,//正在录音中

				localUrl:"",// 本地试听录音文件
			}
		},
		created() {
			// Recorder.ConnectEnableWorklet=true;
			//创建录音对象
			this.rec = Recorder({
				type:'pcm',// 录音格式，可以换成wav等其他格式
				sampleRate:16000, // 录音的采样率，越大细节越丰富越细腻
				bitRate: 16,// 录音的比特率，越大音质越好
				onProcess: ( buffers, powerLevel, bufferDuration, bufferSampleRate, newBufferIdx, asyncEnd) => {
					//录音实时回调，大约1秒调用12次本回调
					// 可安時絵制波形，实时上传(发送)数据
					// if (this.wave) {
					// 	this.wave.input (
					// 		buffers[buffers.length - 1], powerLevel, bufferSampleRate
					// 	)
					// }
				}
			})
			//打开录音，荻得权限
			this.rec.open(
				() => {
					console.log("录音已打开")
				},
				(msg, isuserNotAllow) => {
					//用户拒绝了录音权限，或者浏览器不支持录音
					this.$toast ({
						message: (isUserNotAllow ? 'UserNotAllow, ' : '') + msg, 
						type: 'success'
					})
				}
			)
		},
		destroyed(){
			this.rec.close();
		},
		methods: {
			touchStart(event){
				event.preventDefault();//阻止浏览器默认行为
				this.posStart = event.touches[0].pageY;//获取起点坐标
				this.recStart();
			},
			touchMove(event){
				event.preventDefault();//阻止浏览器默认行为
				this.posMove = event.targetTouches[0].pageY;//获取滑动实时坐标
				if (this.posStart - this.posMove < 150) {
						this.isCancel = false;
				} else {
					this.isCancel = true;
				}
			},
			touchEnd(event){
				event.preventDefault(); //阻止浏览器默认行为
				this.posEnd = event.changedTouches[0].pageY;//获取终点坐标
				//初始化状态
				// this.initStatus();
				// if (this.posStart - this.posEnd < 150) {
				// 		console.log("确定发送");
				// 		this.recStop()
				// } else {
				// 	// this.reset();
				// 	this.isCancel=false;
				// 	console.log("确定取消发送");
				// }
				this.recStop();
				this.isCancel=false;
				this.isSounding=false;
			},
			//初始化状态
			initStatus() {
				this.isSounding = false;
				this.isCancel = false;
			},
			/**
			 * @description: 切换键盘
			 * @return {*}
			 */	
			switchKeyboard(event){
				event.stopPropagation();
				event.preventDefault(); //阻止浏览器默认行为
				this.$emit("methodChange","keyboard")
			},
			//开始录音
			recStart() {
				if (!this.rec) {
					this.$toast({
						message: "未初始化录音",type: 'fail'
					})
					return
				}
				this.isSounding = true;
				this.rec.start()
			},
			//結束彔音
			recStop() {
				if (!this.rec) {
					this.$toast({ message:"未打开录音",	type: 'fail' });
					return
				}
				this.isSounding = false;
				this.rec.stop(
					(blob, duration) => {
						// envInlast 录制结束时间  envInFirst 录制开始时间
						// const time = this.rec.envInLast - this.rec.envInFirst
						// //获取录制时间 需求至少录制三秒
						if (duration < 1000) {
							this.$toast({
								message:"至少录制一秒",
								type: 'fail'
							})
							return
						}
						if (this.posStart - this.posEnd >= 150) {//手指滑动到了取消发送区域
							return false;
						}
						//b1ob就是我们要的录音文件对象，可以上传，或者本地播放
						// this.recBlob = blob
						this.blobToBase64(blob).then(res => {
							this.$emit("soundEnd",res)
						});
					},
					(err) => {
						console.error("结束录音出错：，"+ err)
						// this.$toast({
						// 	message:"结束录音出错："+ err,
						// 	type: 'fail'
						// })
						// this.reset ('now')
					}
				)
			},
			/**
				*blob转base64
				* @param blob
			*/
			blobToBase64 (blob) {
				return new Promise ((resolve, reject) => {
					const fileReader = new FileReader ();
					fileReader.onload = (e) => {
						const result = e.target.result.replace(/data.+?;base64,/, "");
						resolve(result)
					}
					// readAsDataURL
					fileReader.readAsDataURL(blob)
					fileReader.onerror = () => {
						reject(new Error('blobToBase64 error'))
					}
				})
			},
			//本地试听
			recPlay(blob) {
				//本地播放录音试听，可以直接用URL把b1ob转换成本地播放地址，用audio进行播放
				var localUrl = URL.createObjectURL(blob)
				var audio = document.createElement('audio')
				audio.controls = true
				document.body.appendChild(audio)
				audio.src = localUrl
				audio.play()//这样就能播放了
				// 注意不用了时需要revokeobjectURL，否则霸占内存
				setTimeout(function() {
					URL.revokeObjectURL(audio.src)
				}, 5000)
			},
			//重置
			reset(type) {
				//当在录音时 如页面退出需重置否则再次进入页面录音会报错(同时清除toast提示）
				if (!type) {
					this.$toast.clear()
				}
				if (this.rec) {
					this.rec.close() // 关闭录音，释放录音资源，当然可以不释放，后面可以连续调用start
					this.rec = null
					this.isSounding = false;
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.main{
		position: fixed;
		left: 0;
		right: 0;
		bottom: 18px;
		.btn-recod{
			width: 345px;
			height: 48px;
			border-radius: 11px;
			overflow: hidden;
			display: flex;
			align-items: center;
			justify-content: center;
			box-shadow: 0px 1px 18px rgba(0,0,0,0.12);
			position: absolute;
			left: 50%;
			bottom: 15px;
			transform: translateX(-50%);
			.not-sound-box{
				width: 100%;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 17px;
				color: #333333;
				background: #ffffff;
				.icon{
					width: 60px;
					display: flex;
					align-items: center;
					justify-content: center;
					position: absolute;
					right: 0;
					top: 0;
					bottom: 0;
					img{
						width: 22px;
						height: 22px;
					}
				}
			}
			.audio {
				width: 100%;
				height: 100%;
				background: #7FBE26;
				display: flex;
				justify-content: center;
				align-items: center;
				gap: 4px;
				// width: 110px;
				// height: 20px;
				.wave {
					display: block;
					width: 5px;
					height: 30px;
					border-radius: 4px;
					background: rgba(255,255,255,.8);
					border-radius: 4px;
					animation: audio-wave 2s ease-in-out infinite;
					// animation-direction: alternate;
					&:nth-child(1) {
						animation-delay: 0.1s;
					}
					&:nth-child(2) {
						animation-delay: 0.5s;
					}
					&:nth-child(3) {
						animation-delay: 0.2s;
					}
					&:nth-child(4) {
						animation-delay: 0.5s;
					}
					&:nth-child(5) {
						animation-delay: 0.3s;
					}
					&:nth-child(6) {
						animation-delay: 0.5s;
					}
					&:nth-child(7) {
						animation-delay: 0.4s;
					}
					&:nth-child(8) {
						animation-delay: 0.3s;
					}
					&:nth-child(9) {
						animation-delay: 0.5s;
					}
					&:nth-child(10) {
						animation-delay: 0.2s;
					}
					&:nth-child(11) {
						animation-delay: 0.1s;
					}
					&:nth-child(12) {
						animation-delay: 0.4s;
					}
					&:nth-child(13) {
						animation-delay: 0.5s;
					}
					&:nth-child(14) {
						animation-delay: 0.4s;
					}
					&:nth-child(15) {
						animation-delay: 0.3s;
					}
				}
				&.red{
					background-color: #DE3500;
				}
			}
		}
		.sound-box{
			padding-top: 56px;
			padding-bottom: 48px;
			overflow: hidden;
			&:before{
				content: "";
				width: 120%;
				height: 100px;
				box-shadow: 0px -4px 16px rgba(0,0,0,0.08);
				background: #ffffff;
				position: absolute;
				left: 50%;
				top: 16px;
				transform: translateX(-50%);
				border-radius: 100% 100% 0 0;

			}
			.cont{
				padding-bottom: 15px;
				width: 100%;
				text-align: center;
				background: #ffffff;
				position: relative;
				display: flex;
				flex-direction: column;
				align-items: center;
				.txt-large{
					font-size: 18px;
					color: #323333;
					line-height: 32px;
					position: relative;
					top: -16px;
				}
				.txt-small{
					font-size: 13px;
					color: #9E9E9E;
					margin-bottom: 10px;
				}
			}
		}
	}
	@keyframes audio-wave {
		0% {
			height: 30px;
			// transform: translateY(0px);
			// background: #ff8e3a;
			transform: scaleY(0.25);
			background: rgba(255,255,255,1);
		}

		25% {
			height: 30px;
			// transform: translateY(0px);
			// background: #9c73f8;
			transform: scaleY(0.5);
			background: rgba(255,255,255,.35);
		}

		50% {
			height: 30px;
			// transform: translateY(0px) scaleY(1);
			// background: #ed509e;
			transform: scaleY(1);
			background: rgba(255,255,255,.55);
		}

		75% {
			height: 30px;
			// transform: translateY(0px);
			// background: #9c73f8;
			transform: scaleY(0.5);
			background: rgba(255,255,255,75);
		}

		100% {
			height: 30px;
			// transform: translateY(0px);
			// background: #0fccce;
			transform: scaleY(0.25);
			background: rgba(255,255,255,1);
		}
	}
</style>